export default __webpack_public_path__ + "static/media/crowd2.cb16f012.JPG";